<div class="map-container">
  <app-standard-map [options]="mapOptions"></app-standard-map>
  
  <div *ngIf="loading" class="map-loading-overlay">
    <div class="loading-content">
      <i class="fas fa-sync-alt loading-icon"></i>
      <p class="loading-text">Actualizando ubicaciones...</p>
    </div>
  </div>
</div>